<body>
  <div id="root">
    <app-nav-menu id="header"></app-nav-menu>
    <div id="content" class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>
</body>
